var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"v-not-found"}},[_c('div',[_c('h1',[_vm._v("Ой, такой страницы не существует")]),_c('button',{on:{"click":function($event){return _vm.$router.push({ name: 'root' })}}},[_vm._v("На главную")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }